import Tabs from './tabs.vue';
export default Tabs;


// WEBPACK FOOTER //
// ./src/components/tabs/index.js